export const formatProduct = (product) => {
    const productMap = {
        'CNC': 'Overnight',
        'NRML': 'Overnight',
        'MIS': 'Intraday',
        'CNC/NRML': 'Overnight',
    };
    return productMap[product] || product;
};

export const getOrderStatusColor = (status) => {
    const statusColorMap = {
        'COMPLETE': 'success.main',
        'CANCELLED': 'error.main',
        'CANCEL_CONFIRMED': 'error.main',
        'REJECTED': 'error.main',
        'PENDING': 'warning.main',
        'EXCHANGE_RESPONSE_PENDING': 'warning.main',
        'OPEN': 'warning.main',
        'PARTIALLY_EXECUTED': 'warning.main',
        'CONFIRMED': 'warning.main'
    };

    return statusColorMap[status] || 'text.secondary';
};

export const getMarginType = (product) => {
    const marginTypeMap = {
        'CNC': 'Overnight',
        'NRML': 'Overnight',
        'MIS': 'Intraday',
    };
    return marginTypeMap[product] || 'overnight';
};

export const getValueColor = (value, specialKeys = []) => {
    const numValue = parseFloat(value);
    if (specialKeys?.includes(value)) {
        return 'success.main';
    }

    if (isNaN(numValue)) {
        return 'text.primary'; // Default color for non-numeric values
    }

    if (numValue > 0) {
        return 'success.main'; // Positive values in green
    } else if (numValue < 0) {
        return 'error.main'; // Negative values in red
    }
    return 'text.primary'; // Zero or neutral values in default color
};


export const formatLastActivityTime = (nanoseconds) => {
    const milliseconds = Math.floor(nanoseconds / 1000000);
    return new Date(milliseconds).toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
};

export const getOrderType = (orderType) => {
    const orderTypeMap = {
        'MARKET': 'MARKET',
        'LIMIT': 'LIMIT',
        'SL': 'SL',
        'SLM': 'STOPLOSSMARKET',
    }
    return orderTypeMap[orderType] || orderType;
};

export const getProductType = (productType, exchnage,is_index=false) => {
    const productMap = {
        'MIS': "MIS",
        "CNC/NRML":exchnage === "NSE" && !is_index ? "CNC" : "NRML",
        "CNC": "CNC",
        "NRML": "NRML",
    }
    return productMap[productType];
};


